import { render, staticRenderFns } from "./DeletePreview.vue?vue&type=template&id=5aa92217&scoped=true&"
import script from "./DeletePreview.vue?vue&type=script&lang=js&"
export * from "./DeletePreview.vue?vue&type=script&lang=js&"
import style0 from "./DeletePreview.vue?vue&type=style&index=0&id=5aa92217&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa92217",
  null
  
)

export default component.exports